<template>
    <div>
        <!-- <h1 class="display-heading">{{title}}<i v-if="isFamily" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" :title="getTitleLabel()"></i></h1> -->
        <h1 class="display-heading">{{title}}</h1>

        <div class="d-flex align-items-baseline">
            <div v-if="isFamily" class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Patient Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter patient name" data-vv-validate-on="blur"
                    v-model="filter.name" v-validate="''"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Created Date:</label>
                <input style="width: 150px" ref="filterDate" type="text" name="filterDate" data-vv-as="filter created date" data-vv-validate-on="blur"
                    v-model="filter.date" v-validate="'date_format:DD/MM/YYYY'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterDate')
                    }" >
                <div v-show="validationErrors.has('filterDate')" class="invalid-feedback">
                    {{ validationErrors.first('filterDate') }}
                </div>
            </div>
            <button @click="getPatientConsultationHistory" class="btn btn-primary">Search</button>
        </div>

        <div class="d-md-none">
            <div class="card mb-3" v-show="consultationList.length === 0">
                <div class="card-body">
                    {{isTableLoading ? "Loading Data": "No Data"}}
                </div>
            </div>

            <div class="card mb-3" v-for="(consultation, index) in consultationList" :key="index">
                <div class="card-body">
                    <div v-if="isFamily" class="mb-3">
                        <label class="label-display">
                            Patient Name
                        </label>
                        <div>
                            {{consultation.patientName}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Date
                        </label>
                        <div>
                            {{consultation.date}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Time
                        </label>
                        <div>
                            {{consultation.time}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Doctor Name
                        </label>
                        <div>
                            {{consultation.doctorName}}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="label-display">
                            Status
                        </label>
                        <div class="mt-2">
                            <span class="badge badge-secondary">
                                Ended
                            </span>
                        </div>
                    </div>
                    <div>
                        <label class="label-display">
                            Action
                        </label>
                        <div class="mt-2">
                            <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'user-clinic-consultation-detail', 'params': {'id': consultation.consultationId}}">View Consultation</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-none d-md-block">
            <div ref="tableSection">
                <div class="table-responsive">
                    <table ref="listTable" class="table table-hover">
                        <colgroup>
                            <col width="40">
                            <col v-if="isFamily">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="100">
                            <col width="200">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" v-if="isFamily">Patient Name</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Doctor Name</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="consultationList.length === 0">
                                <td :colspan="columnsCount" class="text-center font-italic">
                                    {{isTableLoading ? "Loading Data": "No Data"}}
                                </td>
                            </tr>
                            <tr v-for="(consultation, index) in consultationList" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td v-if="isFamily">{{consultation.patientName}}</td>
                                <td class="text-nowrap">{{consultation.date}}</td>
                                <td class="text-nowrap">
                                    {{consultation.time}}
                                </td>
                                <td>{{consultation.doctorName}}</td>
                                <td>
                                    <span class="badge badge-secondary">
                                        Ended
                                    </span>
                                </td>
                                <td>
                                    <router-link :to="{'name': 'user-clinic-consultation-detail', 'params': {'id': consultation.consultationId}}">View Consultation</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination v-model="pagination.currentPage"
                        :totalPages="pagination.totalPages"
                        :scrollPosition="pagination.scrollPosition">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import moment from 'moment';
import {
    convertDateToIso8601
} from '@/utilities';
import appointmentStatusPatient from '@/components/appointment-status/user';
import pagination from '@/components/pagination';
export default {
    'name': 'PatientAppointmentList',
    'components': {
        appointmentStatusPatient,
        pagination
    },
    beforeRouteLeave (to, from, next) {
        this.shouldUpdate = false;
        // console.log('stopped update');
        next();
    },
    data () {
        return {
            // 'title': 'Clinic Consultations',
            'consultationList': [],
            'shouldUpdate': true,
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'filter': {
                'name': null,
                'date': null
            }
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isFamily () {
            return this.$route.name === 'family-clinic-consultation-list';
        },
        title () {
            if (this.isFamily) {
                return 'Family Clinic Consultations';
            }
            return 'Clinic Consultations';
        },
        getApi () {
            if (this.isFamily) {
                return 'Clinic/GetFamilyConsultationHistory';
            }
            return 'Clinic/GetPatientConsultationHistory';
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getPatientConsultationHistory();
            });
        }
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPatientConsultationHistory();
        this.initializeDatePickers();
    },
    'methods': {
        getPatientConsultationHistory () {
            this.isTableLoading = true;
            this.axios.post(this.getApi, {
                'd': convertDateToIso8601(this.filter.date),
                'pn': this.filter.name,
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.consultationList = list.map((consultation) => ({
                    'patientName': consultation.pn,
                    'date': consultation.sa ? moment(consultation.sa).format('DD/MM/YYYY') : null,
                    'time': consultation.sa ? moment(consultation.sa).format('hh:mm A') : null,
                    'doctorName': consultation.dn ? consultation.dn : '-',
                    'status': consultation.s,
                    'consultationId': consultation.ci
                }));

                // if (this.shouldUpdate) {
                //     this.loopGetAppointments = setTimeout(() => {
                //         this.getPatientAppointments();
                //     }, 2000);
                // }
            });
        },
        initializeDatePickers () {
            $(this.$refs.filterDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.filterDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filter.date = picker.startDate.format('DD/MM/YYYY');
                }
            );
        },
        getTitleLabel () {
            return 'Only can view child(ren) aged below 18.\n' +
            'Upon child(ren) attaining age 18 or above, they need to register another personal account with own user ID for migrating their previous medical records.';
        }
    }
};

</script>
